import { DropDown, TextField } from '@elementary/common-ui/components';
import { Period } from '@elementary/common-ui/types';

type Props = {
  disabled: boolean;
  onChange: (value: Partial<Period>) => void;
  count?: Period['count'] | null;
  period?: Period['period'] | null;
  options: { value: string; label: string }[];
  defaultPeriod?: string;
};

const TimeWithUnitField = ({
  disabled,
  onChange,
  count,
  period,
  options,
  defaultPeriod = 'day',
}: Props) => (
  <>
    <TextField
      sx={{ width: '80px', mr: 1 }}
      type="number"
      disabled={disabled}
      value={count ?? 1}
      onChange={(e) => {
        const countValue = Number(e.target.value);
        onChange({ count: countValue, period: period ?? undefined });
      }}
    />
    <DropDown
      sx={{ width: '120px' }}
      options={options}
      sortOptions={false}
      disabled={disabled}
      value={period || defaultPeriod}
      onChange={(e) => {
        onChange({ count: count ?? undefined, period: e });
      }}
    />
  </>
);

export default TimeWithUnitField;
